class CabinetFaqTabs {
  /**
   * @param {HTMLElement} section
   */
  constructor(section) {
    this.section = section;
    this.tabs = Array.from(section.querySelectorAll('[data-cabinet-faq-tab]'));
    this.faqPanel = section.querySelector('[data-cabinet-faq-panel="faqs"]');
    this.reviewsPanel = section.querySelector('[data-cabinet-faq-panel="reviews"]');
    this.initialized = true;

    this.setActiveTab(section.dataset.activeTab || 'faqs');
    this.bindEvents();
  }

  bindEvents() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        const tabName = tab.dataset.cabinetFaqTab;
        this.setActiveTab(tabName);
      });
    });
  }

  setActiveTab(tabName) {
    const showReviews = tabName === 'reviews';

    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.cabinetFaqTab === tabName;
      tab.classList.toggle('cabinet-faq__tab--active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
    });

    if (this.faqPanel) this.faqPanel.hidden = showReviews;
    if (this.reviewsPanel) this.reviewsPanel.hidden = !showReviews;
  }
}

function initializeCabinetFaqTabs(root = document) {
  root.querySelectorAll('[data-cabinet-faq-tabs]').forEach((section) => {
    if (section.cabinetFaqTabs) return;

    section.cabinetFaqTabs = new CabinetFaqTabs(section);
  });
}

document.addEventListener('DOMContentLoaded', () => initializeCabinetFaqTabs());
document.addEventListener('shopify:section:load', (event) =>
  initializeCabinetFaqTabs(event.target)
);
